// src/app/components/HeaderUserMenu.tsx
import { FC, useState } from 'react';
import { useAuth } from '../../../../app/modules/auth';
import { toAbsoluteUrl } from '../../../helpers';
import { ModalUpdate } from './Modal/ModalUpdate';
import ThemeToggle from '../../../../app/components/ThemeToggle';

type ID = undefined | null | number;

const HeaderUserMenu: FC = () => {
  const [ID, setID] = useState<ID>(undefined);
  const { currentUser, logout } = useAuth();

  return (
    <>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
        data-kt-menu='true'
      >
        <div className='menu-item px-3'>
          <div className='menu-content d-flex align-items-center px-3'>
            <div className='symbol symbol-50px me-5'>
              <img alt='Logo' src={toAbsoluteUrl('/media/img/usericon.png')} />
            </div>

            <div className='d-flex flex-column'>
              <div className='fw-bolder d-flex align-items-center fs-5'>
                <span className=''>
                  {currentUser?.firstName} {currentUser?.lastName}
                </span>
              </div>
              <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
                {currentUser?.email}
              </a>
              <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
                {currentUser?.Tenant.Name}
              </a>
            </div>
          </div>
        </div>

        <div className='separator my-2'></div>

        {/* Aquí integramos el ThemeToggle */}
        <div className='menu-item px-5'>
          <ThemeToggle />
        </div>

        {currentUser?.ListPermiso?.includes('User.UpdateProfile') && (
          <>
            <div className='separator my-2'></div>
            <div className='menu-item px-5'>
              <a onClick={() => setID(currentUser?.id)} className='menu-link px-5'>
                Edit User
              </a>
            </div>
          </>
        )}

        <div className='separator my-2'></div>

        <div className='menu-item px-5'>
          <a onClick={logout} className='menu-link px-5'>
            Sign Out
          </a>
        </div>
      </div>
      {ID !== undefined && <ModalUpdate setID={setID} id={ID} />}
    </>
  );
};

export { HeaderUserMenu };
